module.exports = __webpack_public_path__ + "static/media/pyramid.588e21ea.png";